import { render, staticRenderFns } from "./CreateDestination.vue?vue&type=template&id=ef6290e0"
import script from "./CreateDestination.vue?vue&type=script&lang=js"
export * from "./CreateDestination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports